import { Stack } from '@mui/material'
import useFlagCondition from 'components/shared/useFlagCondition'
import { datasetItems } from 'redux/types'
import { DatasetSelection } from './DatasetSelection'
import { PreFilterTitle } from './PreFilterTitle'
import { ScatterDensitySwitchButtons } from './ScatterDensitySwitchButtons'
import useCellVisualizationUrlParams from '../useCellVisualizationUrlParams'

interface Props {
  isPreFilter?: boolean
}

/**
 * Helper to check if the current session is a demo dataset in the directory
 * Returns true only if the session ID matches one of the datasets in datasetItems
 */
export const isDemoDatasetInDirectory = (sessionId: number | undefined): boolean => {
  if (sessionId === undefined || Number.isNaN(sessionId)) {
    return false
  }
  const datasetIds = datasetItems.map((item) => Number(item.id))
  return datasetIds.includes(sessionId)
}

export const CellVizHeaderLeftSideContent = ({ isPreFilter }: Props): JSX.Element => {
  const demoEnabled = useFlagCondition('demoEnabled')
  const { sessionId } = useCellVisualizationUrlParams()

  return (
    <Stack direction="row" spacing={2}>
      {isPreFilter && <PreFilterTitle />}
      {!isPreFilter && <ScatterDensitySwitchButtons />}
      {demoEnabled && isDemoDatasetInDirectory(sessionId) ? <DatasetSelection /> : null}
    </Stack>
  )
}

export default CellVizHeaderLeftSideContent
